<template>
  <card-canvas class="guest-create">
    <guest-upgrade-prompt v-if="!$permissions.canHaveGuests" mode="hero" />
    <template v-else>
      <card-canvas-two-deep-breadcrumb
        :parent-route="RouteAssistant.getGuestsRoute($route.params.accountId)"
        child-name="Invite"
        parent-name="Guests" />
      <h2>Invite Guests</h2>
      <p>
        Enter an email address to invite a guest to a company.
      </p>
      <add-guest-form @account-memberships-created="RouteAssistant.goToGuests($router, $route.params.accountId)" />
    </template>
  </card-canvas>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'
import CardCanvas from '@/layouts/card-canvas.vue'

/* Mixins */

/* Components */
import AddGuestForm from './components/add-guest-form.vue'
import GuestUpgradePrompt from '@/components/global/guest-upgrade-prompt.vue'

/* Helpers */
import RouteAssistant from '@/helpers/route-assistant'

/* Data types */

/* API */

export default defineComponent({
  name: 'GuestsCreate',

  components: {
    CardCanvas,
    AddGuestForm,
    GuestUpgradePrompt,
  },

  data() {
    return {
      RouteAssistant,
    }
  },

  head: {
    title: 'Invite New Guest',
  },
})
</script>

<style lang="scss">
</style>
